export default __webpack_public_path__ + "static/media/tutorial-06.9e9431f5.jpg";